export class AutoOrder {
    packageSizeId: any;
    quantity: number;
    updatedBy: string;
}
